import React from 'react';
import classNames from 'classnames';
import cls from './PeopleInformation.module.css';
import { CustomerRow } from './CustomerRow/CustomerRow';
import { ContractorRow } from './ContractorRow/ContractorRow';
import { ManagerRow } from './ManagerRow/ManagerRow';
import { ProjectTeamRow } from './ProjectTeamRow/ProjectTeamRow';
import { usePeopleInformation } from './usePeopleInformation';

interface PeopleInformationProps {
    classes?: string;
}

export const PeopleInformation = ({ classes }: PeopleInformationProps) => {
    const { is_customer } = usePeopleInformation();
    return (
        <div className={classNames(cls.PeopleInformation, [classes])}>
            <CustomerRow />
            <ContractorRow />
            <ManagerRow />
            {!is_customer && <ProjectTeamRow />}
        </div>
    );
};
